import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';

const response = {};

export const logout = http.post(
  createMockEndpoint('/logout'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
